import { gql } from '@apollo/client';

export const GET_GUIDED_CHATBOT_CHATS = gql`
  query ChatbotChats($params: FindChatbotChatListInput!) {
    chatbotChats(params: $params) {
      success
      message
      errors
      data {
        chats {
          id
          tenantId
          userId
          title
          lastMessageAt
          createdAt
          createdBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_GUIDED_CHATBOT_MESSAGES = gql`
  query ChatbotMessages($params: FindChatbotMessageListInput!) {
    chatbotMessages(params: $params) {
      success
      message
      errors
      data {
        messages {
          id
          chatId
          tenantId
          userId
          role
          content
          feedback
          metadata
          createdAt
          createdBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_ACTIVE_DECISION_TREES = gql`
  query ActiveDecisionTrees {
    activeDecisionTrees {
      success
      message
      errors
      data {
        id
        treeKey
        name
        description
        icon
        displayOrder
        isActive
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
